import { createBrowserLogger } from '@onelab/logger/browser';
import type { BaseLogContext } from '@onelab/logger';
import * as Sentry from '@sentry/sveltekit';

export interface BackofficeLogContext extends BaseLogContext {
  clientId?: number;
  companyId?: number;
  [key: string]: unknown;
}

export const logger = createBrowserLogger<BackofficeLogContext>({
  service: 'backoffice',
  sentry: Sentry,
});
